import type { Event } from '../types';

export const FinishedEventData = {
  FinishQuoteStatus: {
    eventAction: 'Quote Request',
  } as Event<'Failure' | 'Success'>,
  FinishQuotePerformance: {
    eventAction: 'Quote Performance',
  } as Event<''>,
  LongTimeWaiting: {
    eventAction: 'Long Time Waiting',
  } as Event<''>,
  FinishContactJerry: {
    eventAction: 'Call Jerry Clicked',
  } as Event<'' | 'Navigation'>,
  FinishedLanded: {
    eventAction: 'Finished',
  } as Event<''>,
  FinishedAppDownloadViewed: {
    eventAction: 'App Download Viewed',
  } as Event<'iOS - Top' | 'iOS - Bottom' | 'Android - Top' | 'Android - Bottom'>,
  FinishedAppDownloadClicked: {
    eventAction: 'App Download Clicked',
  } as Event<'iOS - Top' | 'iOS - Bottom' | 'Android - Top' | 'Android - Bottom'>,
  FinishedGoodPriceStatus: {
    eventAction: 'Quote Good Price',
  } as Event<string>,
  FinishedNoCarQuotes: {
    eventAction: 'No Car Quotes',
  } as Event<string>,
  ContinueToGeicoClicked: {
    eventAction: 'Continue to Geico Clicked',
  } as Event<'Geico card button' | 'Geico sticky button'>,
  TriggerGeicoRecallJobError: {
    eventAction: 'Trigger Geico Recall Job Error',
  } as Event<string>,
  PullGeicoRecallUrlError: {
    eventAction: 'Pull Geico Recall Url Error',
  } as Event<string>,
  SendUserToGeico: {
    eventAction: 'Send User to Geico',
  } as Event<string>,
  FinishRefiOfferStatus: {
    eventAction: 'Refi Offer Status',
  } as Event<string>,
  CarrierLogoViewed: {
    eventAction: 'View Carrier Logo',
    eventLabel: 'Viewed',
  } as Event<'Viewed'>,
};
